module.exports = __webpack_public_path__ + "img/rockamberg.27f54741.png";